import { FC } from 'react';

interface LabelWithTooltipProps {
  label: string;
  helperText: string;
  className?: string;
}

const LabelWithTooltip: FC<LabelWithTooltipProps> = ({ label, helperText, className = '' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <div className="relative ml-1 group">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block w-48 px-2 py-1 bg-gray-900 text-white text-xs rounded shadow-lg z-10">
          {helperText}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
            <div className="border-4 border-transparent border-t-gray-900"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LabelWithTooltip; 